// extracted by mini-css-extract-plugin
module.exports = {"button":"newBlockToolbar__button___3dSt1"};